import Modal from "../../ui/modal/Modal";
import {OperationErrorApiDto} from "../../../api/model/rest";
import * as React from "react";

interface Props {
	onClose: () => void,
	errorDetails: OperationErrorApiDto;
}

export default class OperationErrorDetailsModal extends React.PureComponent<Props> {
	render() {
		return <Modal onCloseClicked={this.props.onClose}>
			<div>
				<pre style={{whiteSpace: "pre-wrap"}}>
					{JSON.stringify(this.props.errorDetails.data, null, 2)}
				</pre>
			</div>
		</Modal>
	}
}